import * as React from 'react';
import { FieldOptionReadDTO, FieldOptionCreateDTO } from '../generated/api-client';
import { CrudDataGridPage, CrudConfig, CrudField } from '../components/CrudDataGrid';
import { GridRowModel } from '@mui/x-data-grid';
import { apiClient } from '../services/apiClient';

export const FieldOptionsPage: React.FC = () => {
  const fields: CrudField[] = [
    {
      field: 'table_code_index',
      headerName: 'Nome campo',
      width: 200,
      editable: true,
    },
    {
      field: 'option_value',
      headerName: 'Opzione',
      width: 250,
      editable: true,
    },
  ];

  const config: CrudConfig<FieldOptionReadDTO, FieldOptionCreateDTO> = {
    queryKey: 'fieldOptions',
    fields,
    listFn: async () => {
      return await apiClient.list_items_field_option__get();
    },
    createFn: async (data: FieldOptionCreateDTO) => {
      return await apiClient.create_item_field_option__post(data);
    },
    updateFn: async (id: string, data: FieldOptionCreateDTO) => {
      return await apiClient.update_item_field_option__item_id__put(id, data);
    },
    deleteFn: async (id: string) => {
      await apiClient.delete_item_field_option__item_id__delete(id);
    },
    getId: (row: FieldOptionReadDTO) => row.id || '',
    getCreateDto: (row: GridRowModel) => {
      return new FieldOptionCreateDTO({
        table_code_index: row.table_code_index || '',
        option_value: row.option_value || '',
      });
    },
  };

  return <CrudDataGridPage title="Elenco opzioni" config={config} />;
};
